export enum PayloadType {
    CONFIRMED_INVITE = 'confirmedInvite',
    RECEIVED_INVITE = 'receivedInvite',
    SEND_GIFT = 'sendGift',
    HELPER_GIFT = 'helperGift',
    SEND_COINS = 'sendCoins',
    REQUEST_GIFT = 'requestGift',
    MAP_COMPLETE_SHARE = 'mapCompleteShare',
    JACKPOT_SHARE = 'jackpotShare',
}
